import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Button } from 'reactstrap';
import { RootStore } from 'src/Stores/Root/RootStore';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';

@inject('stores')
@observer
export class WellCloseButton extends React.Component {

    public props: any;
    private RootStore: RootStore;
    private WellStore: WellsStore;
    private UserStore: UserStore;
    private TestsStore: TestsStore;

    public state = {
        isClosing: false,
    };
    
    constructor(props: any) {
        super(props);
        this.RootStore = this.props.stores;
        this.WellStore = this.RootStore.WellsStore;
        this.UserStore = this.RootStore.UserStore;
        this.TestsStore = this.RootStore.TestsStore;
    }

    private startWellClose = () => {
        const areYouSure = confirm("Are you sure you want to initiate the Well Close Process?\n\nClick OK to access the Well Close Review pages so that you can reconcile inventory and update recap remarks.\n\nComplete the Well Close Review pages then Close the Well.");
        if (areYouSure) {
            this.setState({isClosing: true});
            this.RootStore.startWellClose()
            .then((data: any) => {
                if (data) {
                    this.props.history.push(`/well/${this.WellStore.well.id}/wellclose/productsreview`);
                }
                this.setState({isClosing: false});
            });
        }
    }

    private wellCloseInProgress = () => {
        const message = "Please confirm that you completed the Well Close Review pages before pressing 'OK' to Close the Well.";
        const areYouSure = confirm(message);
        if (areYouSure) {
            this.WellStore.closeWell().then(data => {
                if(data) {
                    this.RootStore.MessageStore.addMessage('Well Closed Successful', 'success');
                    this.WellStore.getWellDetails(this.WellStore.well.id);
                }
            });
        }
    }

    private wellArchive = () => {
        const message = "Are you sure you want to Archive this Well?\n\nClick OK to change this Well’s status to Archived.";
        const areYouSure = confirm(message);
        if (areYouSure) {
            this.WellStore.archiveWell().then(data => {
                if(data) {
                    this.RootStore.MessageStore.addMessage('Well Archived Successful', 'success');
                }
            });
        }
    }

    private spinnerIcon = () => {
        return (
            <FontAwesomeIcon 
                icon={faSpinner}
                spin={true}
                size={"8x"}
                style={{position: 'fixed', left: '50%', top: '35%'}}
            />
        );
    }

    private hasPermission = () => {
        if (this.UserStore.hasGenericPermission('Permissions.Wells.Close')) {
            if (!this.UserStore.hasPermission('Permissions.Wells.Close.All') && this.WellStore.well) {
                return this.WellStore.well.engineers.some(eng => eng.id === this.UserStore.user.id);
            } else {
                return true;
            }
        }
        return false;
    }

    public render() {

        if (this.state.isClosing) {
            return this.spinnerIcon();
        }
        const currWell = this.WellStore.well;
        if (!currWell) {
            return '';
        }
        
        if (!this.hasPermission()) {
            return '';
        }

        if (this.TestsStore.tests && this.TestsStore.tests.length === 0) {
            return '';
        }

        if (this.TestsStore.tests && this.TestsStore.tests.some(test => test.testStatus !== 'Approved')) {
            return '';
        }
        
        if (currWell.wellStatus === 'Archived') {
            return '';
        }

        if (currWell.wellStatus === 'Closed') {
            return this.UserStore.hasPermission('Permissions.Wells.Archive') ? <Button type="button" color="danger" onClick={this.wellArchive}>Archive Well</Button> : '';
        }
        
        if (currWell.wellStatus === 'Finishing') {
            return <Button type="button" color="danger" onClick={this.wellCloseInProgress}>Close Well</Button>;
        }
        
        return (
            <Button type="button" color="danger" onClick={this.startWellClose}>Start Well Close</Button>
        );


    }

}

export default withRouter(WellCloseButton);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellCloseButton.tsx